import { render, staticRenderFns } from "./TabRichieste.vue?vue&type=template&id=a0443638&scoped=true&"
import script from "./TabRichieste.vue?vue&type=script&lang=js&"
export * from "./TabRichieste.vue?vue&type=script&lang=js&"
import style0 from "./TabRichieste.vue?vue&type=style&index=0&id=a0443638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0443638",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabRichieste.vue
// module id = 439
// module chunks = 0